// =============================================================================
// FILE:
// frontend/src/ipe/pms/components/site_store_dashboard/siteStoreDashboardStyles.js
// =============================================================================

const styles = {

  // ===========================================================================
  // PAGE
  // ===========================================================================

  page: {

    padding: 20,

    background: "#f5f7fb",

    minHeight: "100vh"
  },


  // ===========================================================================
  // HEADER
  // ===========================================================================

  headerCard: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 20,

    marginBottom: 20,

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  headerTitle: {

    fontSize: 24,

    fontWeight: 700,

    color: "#111827"
  },

  headerSubtitle: {

    marginTop: 6,

    fontSize: 14,

    color: "#6b7280"
  },

  headerActions: {

    display: "flex",

    gap: 12
  },

  actionBtn: {

    height: 40,

    border: "1px solid #d1d5db",

    background: "#fff",

    borderRadius: 8,

    padding: "0 14px",

    display: "flex",

    alignItems: "center",

    gap: 8,

    cursor: "pointer",

    fontWeight: 500
  },

  exportBtn: {

    height: 40,

    border: "none",

    background: "#16a34a",

    color: "#fff",

    borderRadius: 8,

    padding: "0 16px",

    display: "flex",

    alignItems: "center",

    gap: 8,

    cursor: "pointer",

    fontWeight: 600
  },


  // ===========================================================================
  // KPI
  // ===========================================================================

  kpiGrid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(180px, 1fr))",

    gap: 16,

    marginBottom: 20
  },

  kpiCard: {

    background: "#fff",

    borderRadius: 14,

    padding: 18,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)",

    transition:
      "transform 0.2s ease, box-shadow 0.2s ease"
  },

  kpiHeader: {

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center"
  },

  kpiTitle: {

    fontSize: 13,

    color: "#6b7280",

    fontWeight: 500
  },

  kpiIcon: {

    fontSize: 24
  },

  kpiValue: {

    marginTop: 16,

    fontSize: 36,

    fontWeight: 700,

    color: "#111827"
  },


  // ===========================================================================
  // FILTER PANEL
  // ===========================================================================

  filterPanel: {

    background: "#fff",

    borderRadius: 14,

    padding: 20,

    marginBottom: 20,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  filterGrid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(4, 1fr)",

    gap: 16,

    marginBottom: 18
  },

  filterLabel: {

    fontSize: 12,

    fontWeight: 600,

    marginBottom: 6,

    color: "#374151"
  },

  input: {

    width: "100%",

    height: 42,

    border:
      "1px solid #d1d5db",

    borderRadius: 8,

    padding: "0 12px",

    outline: "none",

    fontSize: 14,

    background: "#fff"
  },

  select: {

    width: "100%",

    height: 42,

    border:
      "1px solid #d1d5db",

    borderRadius: 8,

    padding: "0 12px",

    outline: "none",

    fontSize: 14,

    background: "#fff"
  },

  searchRow: {

    display: "flex",

    gap: 16
  },

  searchWrap: {

    flex: 1,

    display: "flex",

    alignItems: "center",

    background: "#fff",

    border:
      "1px solid #d1d5db",

    borderRadius: 8,

    padding: "0 12px",

    height: 44
  },

  searchInput: {

    flex: 1,

    border: "none",

    outline: "none",

    marginLeft: 10,

    fontSize: 14,

    background: "transparent"
  },

  applyBtn: {

    height: 44,

    background: "#2563eb",

    color: "#fff",

    border: "none",

    borderRadius: 8,

    padding: "0 20px",

    cursor: "pointer",

    fontWeight: 600
  },


  // ===========================================================================
  // ERROR
  // ===========================================================================

  errorBox: {

    background: "#fee2e2",

    color: "#b91c1c",

    padding: 14,

    borderRadius: 10,

    marginBottom: 20,

    fontWeight: 500
  },


  // ===========================================================================
  // GRID
  // ===========================================================================

  gridCard: {

    background: "#fff",

    borderRadius: 14,

    overflow: "hidden",

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  gridHeader: {

    padding: 18,

    borderBottom:
      "1px solid #e5e7eb",

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center"
  },

  gridTitle: {

    fontSize: 18,

    fontWeight: 700,

    color: "#111827"
  },

  gridCount: {

    fontSize: 13,

    color: "#6b7280"
  },

  tableWrap: {

    overflowX: "auto",

    overflowY: "auto",

    maxHeight: "65vh"
  },

  table: {

    width: "100%",

    borderCollapse: "collapse"
  },

  thead: {

    position: "sticky",

    top: 0,

    zIndex: 5
  },

  theadRow: {

    background: "#f9fafb"
  },

  th: {

    textAlign: "left",

    padding: 14,

    fontSize: 13,

    fontWeight: 700,

    color: "#374151",

    whiteSpace: "nowrap"
  },

  thRight: {

    textAlign: "right",

    padding: 14,

    fontSize: 13,

    fontWeight: 700,

    color: "#374151",

    whiteSpace: "nowrap"
  },

  thCenter: {

    textAlign: "center",

    padding: 14,

    fontSize: 13,

    fontWeight: 700,

    color: "#374151",

    whiteSpace: "nowrap"
  },

  tr: {

    borderTop:
      "1px solid #f1f5f9",

    transition:
      "all 0.2s ease",

    cursor: "pointer"
  },

  td: {

    padding: 14,

    fontSize: 14,

    color: "#111827",

    verticalAlign: "top"
  },

  tdCenter: {

    padding: 14,

    textAlign: "center"
  },

  materialName: {

    fontWeight: 600
  },

  materialCode: {

    fontSize: 12,

    color: "#6b7280",

    marginTop: 4
  },

  materialMeta: {

    fontSize: 11,

    color: "#9ca3af",

    marginTop: 4
  },

  stockCell: {

    padding: 14,

    textAlign: "right",

    fontWeight: 700,

    color: "#2563eb"
  },

  issuedCell: {

    padding: 14,

    textAlign: "right",

    fontWeight: 700,

    color: "#9333ea"
  },

  consumedCell: {

    padding: 14,

    textAlign: "right",

    fontWeight: 700,

    color: "#0891b2"
  },

  pendingCell: {

    padding: 14,

    textAlign: "right",

    fontWeight: 700,

    color: "#ea580c"
  },

  emptyTd: {

    padding: 30,

    textAlign: "center",

    color: "#6b7280",

    fontWeight: 500
  },


  // ===========================================================================
  // STATUS BADGES
  // ===========================================================================

  statusHealthy: {

    background: "#dcfce7",

    color: "#166534",

    borderRadius: 20,

    padding: "6px 12px",

    fontSize: 11,

    fontWeight: 700
  },

  statusLow: {

    background: "#fef3c7",

    color: "#92400e",

    borderRadius: 20,

    padding: "6px 12px",

    fontSize: 11,

    fontWeight: 700
  },

  statusCritical: {

    background: "#fee2e2",

    color: "#991b1b",

    borderRadius: 20,

    padding: "6px 12px",

    fontSize: 11,

    fontWeight: 700
  }
};

export default styles;